// import React, { useState } from 'react';
// import { Card, CardBody, CardHeader } from '../../../components/card/card';
import Loading from '../../../components/Shared/Loader/Loading';
// import { ModuleCard } from './ModuleCard';
import useLookupModule from '../../../hooks/Lookups/use-Lookup-Module';
import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
import useGetDynamicForm from '../../../hooks/Forms/useGetDynamicForm';
import useGetPrintTemplateList from '../../../hooks/NTX/useGetPrintTemplateList';
import useGetReportsList from '../../../hooks/NTX/useGetReportsList';
// import useGetUsers from '../../../hooks/NTX/useGetUsers';
import useGetNotificationList from '../../../hooks/NTX/useGetNotificationList';
import useGetDashboardsList from '../../../hooks/NTX/useGetDashboardsList';
// import { UsersCard } from './UsersCard';

// const NtxDashboard = () => {
//   const [moduleId, setModuleId] = useState('0a6c6b89-1d52-4eaa-8d2c-010c74b1f6e0'); // الموارد البشرية افتراضي

//   const { i18n } = useTranslation();
//   const { Module } = useLookupModule();

// const { DynamicExtraInformation, DynamicExtraRecord, DynamicFormAme } = useGetDynamicForm();

// const { PrintTemplateList } = useGetPrintTemplateList();

// const { ReportsList } = useGetReportsList();

// const { Users } = useGetUsers();

// const { NotificationsList } = useGetNotificationList();

// const { DashBoardList, loading } = useGetDashboardsList();

//   const excludedIds = [
//     '0a6c6b89-1d52-4eaa-8d2c-060c74b1f6e0',
//     '0a6c6b89-1d52-4eaa-8d2c-000c74b1f6e0',
//   ];
//   const ModuleFilter = Module?.filter((f: any) => !excludedIds.includes(f.id));

//   return (
//     <div>
//       <Loading loading={loading}>
//         <Card className="mb-2">
//           <CardHeader className="px-3 py-0">
//             <ul className="nav nav-pills card-header-pills  d-flex m-0 p-0 w-100 ">
//               {ModuleFilter?.map((m: any) => (
//                 <li className="nav-item flex-fill m-1 " key={m.id}>
//                   <Link
//                     className={` nav-link text-center ${m.id === moduleId ? 'active' : ''}`}
//                     id="pills-home-tab"
//                     data-bs-toggle="pill"
//                     to="#pills-home"
//                     onClick={() => setModuleId(m.id)}>
//                     {i18n.language === 'en' ? m.name : m.name2}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </CardHeader>
//         </Card>

//         <CardBody>
//           <div className="row">
//             <div className="col-xl-3 col-lg-6">
//               <UsersCard title="المستخدمين" icon="bi-file-earmark-plus" List={Users} />
//             </div>
//             <div className="col-xl-3 col-lg-6">
//               <ModuleCard
//                 title="نماذج البيانات الإضافية"
//                 icon="bi-file-earmark-plus"
//                 List={DynamicExtraInformation?.filter((f: any) => f.moduleId === moduleId)}
//               />
//             </div>
//             <div className="col-xl-3 col-lg-6">
//               <ModuleCard
//                 title="نماذج السجلات الإضافية"
//                 icon="bi-journal-plus "
//                 List={DynamicExtraRecord?.filter((f: any) => f.moduleId === moduleId)}
//               />
//             </div>
//             <div className="col-xl-3 col-lg-6">
//               <ModuleCard
//                 title="نماذج الطلبات"
//                 icon="bi-file-earmark-text"
//                 List={DynamicFormAme?.filter((f: any) => f.moduleId === moduleId)}
//               />
//             </div>
//             <div className="col-xl-3 col-lg-6">
//               <ModuleCard
//                 title="التقارير"
//                 icon="bi-file-earmark-bar-graph"
//                 List={ReportsList?.filter((f: any) => f.moduleId === moduleId)}
//               />
//             </div>
//             <div className="col-xl-3 col-lg-6">
//               <ModuleCard
//                 title="قوالب الطباعة"
//                 icon="bi-printer"
//                 List={PrintTemplateList?.filter((f: any) => f.moduleId === moduleId)}
//               />
//             </div>
//             <div className="col-xl-3 col-lg-6">
//               <ModuleCard
//                 title="الإشعارات"
//                 icon="bi-bell"
//                 List={NotificationsList?.filter((f: any) => f.moduleId === moduleId)}
//               />
//             </div>
//             <div className="col-xl-3 col-lg-6">
//               <ModuleCard
//                 title="لوحات البيانات"
//                 icon="bi bi-pie-chart"
//                 List={DashBoardList?.filter((f: any) => f.moduleId === moduleId)}
//               />
//             </div>
//           </div>
//         </CardBody>
//       </Loading>
//     </div>
//   );
// };

// export default NtxDashboard;

import React, { useState } from 'react';
import { Card, CardBody } from '../../../components/card/card';
import {
  ChevronRight,
  ChevronLeft,
  Users,
  BarChart,
  Bell,
  Briefcase,
  DollarSign,
  CalendarCheck,
  CheckCircle,
  PenTool,
  Truck,
  Banknote,
  Box,
  ShoppingCart,
  Receipt,
  Layers,
} from 'lucide-react';
import { ModuleCard2 } from './ModuleCard2';

const NtxDashboard = () => {
  const { t } = useTranslation();
  const [moduleId, setModuleId] = useState('0a6c6b89-1d52-4eaa-8d2c-010c74b1f6e0');
  const [isRTL, setIsRTL] = useState(false);
  const { Module } = useLookupModule();

  const {
    DynamicExtraInformation,
    DynamicExtraRecord,
    DynamicFormAme,
    loading: loading1,
    error: error1,
  } = useGetDynamicForm();

  const { PrintTemplateList, loading: loading2, error: error2 } = useGetPrintTemplateList();

  const { ReportsList, loading: loading3, error: error3 } = useGetReportsList();

  // const { Users } = useGetUsers();

  const { NotificationsList } = useGetNotificationList();

  const { DashBoardList, loading: loading4, error: error4 } = useGetDashboardsList();

  const ModuleFilter = [
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-000c74b1f6e0',
      name: 'General System',
      name2: 'النظام العام',
      icon: PenTool,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-001c74b1f6e0',
      name: 'Reports Management',
      name2: 'إدارة التقارير وقوالب الطباعة',
      icon: BarChart,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-002c74b1f6e0',
      name: 'Notifications System',
      name2: 'إدارة الإشعارات',
      icon: Bell,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-010c74b1f6e0',
      name: 'Human Resources',
      name2: 'إدارة الموظفين',
      icon: Users,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-011c74b1f6e0',
      name: 'Payroll Management',
      name2: 'إدارة الرواتب',
      icon: DollarSign,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-012c74b1f6e0',
      name: 'Attendance Management',
      name2: 'إدارة الحضور',
      icon: CalendarCheck,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-020c74b1f6e0',
      name: 'Approvals Management',
      name2: 'إدارة الموافقات',
      icon: CheckCircle,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-030c74b1f6e0',
      name: 'Supporting Units',
      name2: 'الخدمات المساندة',
      icon: Briefcase,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-040c74b1f6e0',
      name: 'Fleet Management',
      name2: 'إدارة الاسطول',
      icon: Truck,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-050c74b1f6e0',
      name: 'Finance Management',
      name2: 'إدارة المالية',
      icon: Banknote,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-051c74b1f6e0',
      name: 'Fixed Assets Management',
      name2: 'إدارة الأصول',
      icon: Layers,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-052c74b1f6e0',
      name: 'Payables Management',
      name2: 'إدارة المدفوعات',
      icon: DollarSign,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-053c74b1f6e0',
      name: 'Receivables Management',
      name2: 'إدارة المستحقات',
      icon: Receipt,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-060c74b1f6e0',
      name: 'Integration Management',
      name2: 'إدارة التكامل',
      icon: PenTool,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-070c74b1f6e0',
      name: 'Inventory Management',
      name2: 'إدارة المخزون',
      icon: Box,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-080c74b1f6e0',
      name: 'Sales Management',
      name2: 'إدارة المبيعات',
      icon: ShoppingCart,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-081c74b1f6e0',
      name: 'Point Of Sales Management',
      name2: 'إدارة نقاط البيع',
      icon: ShoppingCart,
    },
    {
      id: '0a6c6b89-1d52-4eaa-8d2c-090c74b1f6e0',
      name: 'Purchase Management',
      name2: 'إدارة المشتريات',
      icon: ShoppingCart,
    },
  ].map((item) => ({
    ...item,
    active: Module?.some((s: any) => s.id === item.id) || false,
  }));

  const handleScroll = (direction: any) => {
    const container = document.getElementById('module-nav');
    const scrollAmount = 300;
    if (container) {
      container.scrollBy({
        left: direction === 'right' ? scrollAmount : -scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      <Loading
        loading={loading1 || loading2 || loading3 || loading4 || loading4}
        error={error1 || error2 || error3 || error4}>
        <>
          <Card className="mb-3">
            <CardBody className="p-0">
              <div className="position-relative">
                <button
                  className="btn btn-icon btn-theme position-absolute start-0 top-50 translate-middle-y z-1 ms-2"
                  onClick={() => handleScroll('left')}>
                  <ChevronLeft size={20} />
                </button>

                <div
                  id="module-nav"
                  className="scroll-wrapper"
                  style={{
                    overflowX: 'hidden',
                    margin: '0 40px',
                    WebkitMaskImage:
                      'linear-gradient(to right, transparent, black 20px, black 95%, transparent)',
                  }}>
                  <div className="d-flex gap-2 py-3 px-2">
                    {ModuleFilter?.filter((f) => f.active)?.map((module) => (
                      <button
                        key={module.id}
                        onClick={() => setModuleId(module.id)}
                        className={`btn ${
                          moduleId === module.id ? 'btn-theme' : 'btn-default'
                        } d-flex align-items-center gap-2 px-3 py-2`}
                        style={{ whiteSpace: 'nowrap', transition: 'all 0.2s' }}>
                        <module.icon size={18} />
                        <span>{isRTL ? module.name2 : module.name}</span>
                      </button>
                    ))}
                  </div>
                </div>

                <button
                  className="btn btn-icon btn-theme position-absolute end-0 top-50 translate-middle-y z-1 me-2"
                  onClick={() => handleScroll('right')}>
                  <ChevronRight size={20} />
                </button>
              </div>
            </CardBody>
          </Card>

          <div className="records-dashboard">
            {/* <div className="quick-stats mb-3">
          <Card>
            <CardBody className="d-flex gap-3 p-3">
              <div className="stat-item">
                <i className="bi bi-file-text text-theme me-2"></i>
                Total Records: {DynamicExtraRecord.length * 8}
              </div>
              <div className="stat-item">
                <i className="bi bi-clock-history text-theme me-2"></i>
                Last Updated: 2 mins ago
              </div>
              <div className="ms-auto">
                <button className="btn btn-sm btn-default me-2">
                  <i className="bi bi-grid me-1"></i> Grid
                </button>
                <button className="btn btn-sm btn-theme">
                  <i className="bi bi-plus-lg me-1"></i> New Record
                </button>
              </div>
            </CardBody>
          </Card>
        </div> */}

            <div className="row g-3">
              <ModuleCard2
                title={t('ExtraInfoForm')}
                List={DynamicExtraInformation?.filter((f: any) => f.moduleId === moduleId)}
                url="/Forms/ExtraInformationForm"
              />

              <ModuleCard2
                title={t('ExtraRecordForm')}
                List={DynamicExtraRecord?.filter((f: any) => f.moduleId === moduleId)}
                url="/Forms/ExtraRecordsForm"
              />

              <ModuleCard2
                title={t('RequestForms')}
                List={DynamicFormAme?.filter((f: any) => f.moduleId === moduleId)}
                url="/Ame/Forms"
              />

              <ModuleCard2
                title={t('Reports')}
                List={ReportsList?.filter((f: any) => f.moduleId === moduleId)}
              />

              <ModuleCard2
                title={t('PrintingTemplates')}
                List={PrintTemplateList?.filter((f: any) => f.moduleId === moduleId)}
              />

              <ModuleCard2
                title={t('NOTIFICATIONS')}
                List={NotificationsList?.filter((f: any) => f.moduleId === moduleId)}
              />

              <ModuleCard2
                title={t('Dashboard')}
                List={DashBoardList?.filter((f: any) => f.moduleId === moduleId)}
              />
            </div>
          </div>
        </>
      </Loading>
      <style>{`
          .record-card {
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }

          .record-card:hover {
            transform: translateY(-3px);
          }

          .record-status-indicator {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: var(--bs-theme);
            box-shadow: 0 0 0 4px rgba(var(--bs-theme-rgb), 0.1);
            animation: pulse 3s infinite;
          }

          .records-scroll {
            height: 300px;
            background: var(--bs-body-bg);
          }

          .record-item {
            position: relative;
            padding: 0.75rem 1rem;
            border-bottom: 1px solid var(--bs-border-color);
            transition: all 0.2s ease;
          }

          .record-item:hover {
            background: rgba(var(--bs-theme-rgb), 0.03);
            padding-left: 1.5rem;
          }

          .record-item:hover .record-actions {
            opacity: 1;
            transform: translateX(0);
          }

          .record-content {
            display: flex;
            align-items: center;
            gap: 1rem;
          }

          .record-icon {
            width: 40px;
            height: 40px;
            border-radius: 10px;
            background: rgba(var(--bs-theme-rgb), 0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--bs-theme);
            transition: transform 0.2s ease;
          }

          .record-item:hover .record-icon {
            transform: scale(1.1);
          }

          .record-details {
            flex: 1;
            min-width: 0;
          }

          .record-name {
            font-weight: 500;
            margin-bottom: 0.25rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .record-table {
            color: var(--bs-body-color);
            opacity: 0.6;
          }

          .record-actions {
            display: flex;
            gap: 0.5rem;
            opacity: 0;
            transform: translateX(10px);
            transition: all 0.2s ease;
          }

          .action-btn {
            width: 28px;
            height: 28px;
            border: none;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s ease;
          }

          .action-btn.edit {
            background: rgba(var(--bs-theme-rgb), 0.1);
            color: var(--bs-theme);
          }

          .action-btn.view {
            background: var(--bs-theme);
            color: white;
          }

          .action-btn:hover {
            transform: scale(1.1);
          }

          @keyframes pulse {
            0% {
              box-shadow: 0 0 0 0 rgba(var(--bs-theme-rgb), 0.4);
            }
            70% {
              box-shadow: 0 0 0 10px rgba(var(--bs-theme-rgb), 0);
            }
            100% {
              box-shadow: 0 0 0 0 rgba(var(--bs-theme-rgb), 0);
            }
          }
        `}</style>
    </>
  );
};

export default NtxDashboard;

// <div className="row g-3">
// {[...Array(8)].map((_, index) => (
//   <div key={index} className="col-xl-3 col-lg-6">
//     <Card className="record-card">
//       <CardHeader className="d-flex justify-content-between align-items-center p-3 border-0">
//         <div className="d-flex align-items-center">
//           <div className="record-status-indicator"></div>
//           <h6 className="mb-0 ms-2">Records Group {index + 1}</h6>
//         </div>
//         <div className="card-actions">
//           <button className="btn btn-icon btn-light btn-xs me-1">
//             <i className="bi bi-search"></i>
//           </button>
//           <button className="btn btn-icon btn-light btn-xs">
//             <i className="bi bi-three-dots-vertical"></i>
//           </button>
//         </div>
//       </CardHeader>

//       <CardBody className="p-0">
//         <PerfectScrollbar className="records-scroll">
//           {DynamicExtraRecord.map((record) => (
//             <div key={record.id} className="record-item">
//               <div className="record-content">
//                 <div className="record-icon">
//                   <i className={`${record.icon}`}></i>
//                 </div>
//                 <div className="record-details">
//                   <div className="record-name">{isRTL ? record.name2 : record.name}</div>
//                   <small className="record-table">{record.tableName}</small>
//                 </div>
//                 <div className="record-actions">
//                   <button className="action-btn edit">
//                     <i className="bi bi-pencil"></i>
//                   </button>
//                   <button className="action-btn view">
//                     <i className="bi bi-eye"></i>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </PerfectScrollbar>

//         <div className="card-footer border-0 bg-theme bg-opacity-5 p-2">
//           <div className="d-flex justify-content-between align-items-center">
//             <small>{DynamicExtraRecord.length} Records</small>
//             <button className="btn btn-xs btn-theme">View All</button>
//           </div>
//         </div>
//       </CardBody>
//     </Card>
//   </div>
// ))}
// </div>
